export enum StatiUtenteMaster {
  InBozza = 1,
  InvioMailInCorso = 2,
  Attivo = 3,
  EmailNonConfermata = 4,
  InAttesaConfermaEmail = 5,
  ErroreInvioEmail = 6,
}
